import { useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import HowToRegister from './components/HowToRegister';
import MultipleRegistrationForm from './components/MultipleRegistrationForm';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { SchemaOrg } from '@/utils/seo';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://alaqua.bucketlistgolf.org';

  const eventSchema = {
    name: 'Post-PGA Show at Alaqua Country Club',
    description: 'Play Alaqua Country Club in the Post-PGA Show Bucket List Event. Secure your spot at one of Florida\'s most exclusive golf courses.',
    startDate: '2025-02-01',
    endDate: '2025-02-01',
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    location: {
      '@type': 'Place',
      name: 'Alaqua Country Club',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '1700 Alaqua Drive',
        addressLocality: 'Longwood',
        addressRegion: 'FL',
        postalCode: '32779',
        addressCountry: 'US'
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '28.7003',
        longitude: '-81.3384'
      }
    },
    organizer: {
      '@type': 'Organization',
      name: 'Bucket List Golf Series',
      url: baseUrl
    },
    offers: {
      '@type': 'Offer',
      url: baseUrl,
      availability: 'https://schema.org/InStock',
      validFrom: '2025-01-01'
    }
  };

  const organizationSchema = {
    name: 'Bucket List Golf Series',
    url: baseUrl,
    logo: `${baseUrl}/logo.png`,
    description: 'Premier golf event series featuring exclusive courses and curated experiences for golf enthusiasts.',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'chris.leary@bucketlistgolf.org',
      contactType: 'Customer Service'
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <SchemaOrg type="SportsEvent" data={eventSchema} />
      <SchemaOrg type="Organization" data={organizationSchema} />
      <div className="min-h-screen bg-white">
        <Navigation isScrolled={isScrolled} />
        <main>
          <HeroSection />
          <AboutSection />
          <HowToRegister />
          <MultipleRegistrationForm />
          <FAQSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
}
